var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import convert from 'react-from-dom';
import { canUseDOM, isSupportedEnvironment, omit, randomString, STATUS } from './helpers';
export var cacheStore = Object.create(null);
var InlineSVG = /** @class */ (function (_super) {
    __extends(InlineSVG, _super);
    function InlineSVG(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "hash", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isActive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "isInitialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "handleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (error) {
                var onError = _this.props.onError;
                var status = error.message === 'Browser does not support SVG' ? STATUS.UNSUPPORTED : STATUS.FAILED;
                /* istanbul ignore else */
                if (_this.isActive) {
                    _this.setState({ status: status }, function () {
                        /* istanbul ignore else */
                        if (typeof onError === 'function') {
                            onError(error);
                        }
                    });
                }
            }
        });
        Object.defineProperty(_this, "handleLoad", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (content, hasCache) {
                if (hasCache === void 0) { hasCache = false; }
                /* istanbul ignore else */
                if (_this.isActive) {
                    _this.setState({
                        content: content,
                        hasCache: hasCache,
                        status: STATUS.LOADED,
                    }, _this.getElement);
                }
            }
        });
        Object.defineProperty(_this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, cacheRequests, fetchOptions, src, response, contentType, _b, fileType_1, content, currentSrc, cache, error_1, cache;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = this.props, cacheRequests = _a.cacheRequests, fetchOptions = _a.fetchOptions, src = _a.src;
                            if (cacheRequests) {
                                cacheStore[src] = { content: '', status: STATUS.LOADING };
                            }
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, fetch(src, fetchOptions)];
                        case 2:
                            response = _c.sent();
                            contentType = response.headers.get('content-type');
                            _b = __read((contentType || '').split(/ ?; ?/), 1), fileType_1 = _b[0];
                            if (response.status > 299) {
                                throw new Error('Not found');
                            }
                            if (!['image/svg+xml', 'text/plain'].some(function (d) { return fileType_1.includes(d); })) {
                                throw new Error("Content type isn't valid: ".concat(fileType_1));
                            }
                            return [4 /*yield*/, response.text()];
                        case 3:
                            content = _c.sent();
                            currentSrc = this.props.src;
                            // the current src don't match the previous one, skipping...
                            if (src !== currentSrc) {
                                if (cacheStore[src].status === STATUS.LOADING) {
                                    delete cacheStore[src];
                                }
                                return [2 /*return*/];
                            }
                            this.handleLoad(content);
                            /* istanbul ignore else */
                            if (cacheRequests) {
                                cache = cacheStore[src];
                                /* istanbul ignore else */
                                if (cache) {
                                    cache.content = content;
                                    cache.status = STATUS.LOADED;
                                }
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            error_1 = _c.sent();
                            this.handleError(error_1);
                            /* istanbul ignore else */
                            if (cacheRequests) {
                                cache = cacheStore[src];
                                /* istanbul ignore else */
                                if (cache) {
                                    delete cacheStore[src];
                                }
                            }
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            }); }
        });
        _this.state = {
            content: '',
            element: null,
            hasCache: !!props.cacheRequests && !!cacheStore[props.src],
            status: STATUS.IDLE,
        };
        _this.hash = props.uniqueHash || randomString(8);
        return _this;
    }
    Object.defineProperty(InlineSVG.prototype, "componentDidMount", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.isActive = true;
            if (!canUseDOM() || this.isInitialized) {
                return;
            }
            var status = this.state.status;
            var src = this.props.src;
            try {
                /* istanbul ignore else */
                if (status === STATUS.IDLE) {
                    /* istanbul ignore else */
                    if (!isSupportedEnvironment()) {
                        throw new Error('Browser does not support SVG');
                    }
                    /* istanbul ignore else */
                    if (!src) {
                        throw new Error('Missing src');
                    }
                    this.load();
                }
            }
            catch (error) {
                this.handleError(error);
            }
            this.isInitialized = true;
        }
    });
    Object.defineProperty(InlineSVG.prototype, "componentDidUpdate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (previousProps, previousState) {
            if (!canUseDOM()) {
                return;
            }
            var _a = this.state, hasCache = _a.hasCache, status = _a.status;
            var _b = this.props, onLoad = _b.onLoad, src = _b.src;
            if (previousState.status !== STATUS.READY && status === STATUS.READY) {
                /* istanbul ignore else */
                if (onLoad) {
                    onLoad(src, hasCache);
                }
            }
            if (previousProps.src !== src) {
                if (!src) {
                    this.handleError(new Error('Missing src'));
                    return;
                }
                this.load();
            }
        }
    });
    Object.defineProperty(InlineSVG.prototype, "componentWillUnmount", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.isActive = false;
        }
    });
    Object.defineProperty(InlineSVG.prototype, "getElement", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            try {
                var node = this.getNode();
                var element = convert(node);
                if (!element || !React.isValidElement(element)) {
                    throw new Error('Could not convert the src to a React element');
                }
                this.setState({
                    element: element,
                    status: STATUS.READY,
                });
            }
            catch (error) {
                this.handleError(new Error(error.message));
            }
        }
    });
    Object.defineProperty(InlineSVG.prototype, "getNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a = this.props, description = _a.description, title = _a.title;
            try {
                var svgText = this.processSVG();
                var node = convert(svgText, { nodeOnly: true });
                if (!node || !(node instanceof SVGSVGElement)) {
                    throw new Error('Could not convert the src to a DOM Node');
                }
                var svg = this.updateSVGAttributes(node);
                if (description) {
                    var originalDesc = svg.querySelector('desc');
                    if (originalDesc && originalDesc.parentNode) {
                        originalDesc.parentNode.removeChild(originalDesc);
                    }
                    var descElement = document.createElementNS('http://www.w3.org/2000/svg', 'desc');
                    descElement.innerHTML = description;
                    svg.prepend(descElement);
                }
                if (typeof title !== 'undefined') {
                    var originalTitle = svg.querySelector('title');
                    if (originalTitle && originalTitle.parentNode) {
                        originalTitle.parentNode.removeChild(originalTitle);
                    }
                    if (title) {
                        var titleElement = document.createElementNS('http://www.w3.org/2000/svg', 'title');
                        titleElement.innerHTML = title;
                        svg.prepend(titleElement);
                    }
                }
                return svg;
            }
            catch (error) {
                return this.handleError(error);
            }
        }
    });
    Object.defineProperty(InlineSVG.prototype, "load", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            /* istanbul ignore else */
            if (this.isActive) {
                this.setState({
                    content: '',
                    element: null,
                    hasCache: false,
                    status: STATUS.LOADING,
                }, function () {
                    var _a = _this.props, cacheRequests = _a.cacheRequests, src = _a.src;
                    var cache = cacheRequests && cacheStore[src];
                    if (cache && cache.status === STATUS.LOADED) {
                        _this.handleLoad(cache.content, true);
                        return;
                    }
                    var dataURI = src.match(/^data:image\/svg[^,]*?(;base64)?,(.*)/u);
                    var inlineSrc;
                    if (dataURI) {
                        inlineSrc = dataURI[1] ? window.atob(dataURI[2]) : decodeURIComponent(dataURI[2]);
                    }
                    else if (src.includes('<svg')) {
                        inlineSrc = src;
                    }
                    if (inlineSrc) {
                        _this.handleLoad(inlineSrc);
                        return;
                    }
                    _this.request();
                });
            }
        }
    });
    Object.defineProperty(InlineSVG.prototype, "processSVG", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var content = this.state.content;
            var preProcessor = this.props.preProcessor;
            if (preProcessor) {
                return preProcessor(content);
            }
            return content;
        }
    });
    Object.defineProperty(InlineSVG.prototype, "updateSVGAttributes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var _this = this;
            var _a = this.props, _b = _a.baseURL, baseURL = _b === void 0 ? '' : _b, uniquifyIDs = _a.uniquifyIDs;
            var replaceableAttributes = ['id', 'href', 'xlink:href', 'xlink:role', 'xlink:arcrole'];
            var linkAttributes = ['href', 'xlink:href'];
            var isDataValue = function (name, value) {
                return linkAttributes.includes(name) && (value ? !value.includes('#') : false);
            };
            if (!uniquifyIDs) {
                return node;
            }
            __spreadArray([], __read(node.children), false).forEach(function (d) {
                if (d.attributes && d.attributes.length) {
                    var attributes_1 = Object.values(d.attributes).map(function (a) {
                        var attribute = a;
                        var match = a.value.match(/url\((.*?)\)/);
                        if (match && match[1]) {
                            attribute.value = a.value.replace(match[0], "url(".concat(baseURL).concat(match[1], "__").concat(_this.hash, ")"));
                        }
                        return attribute;
                    });
                    replaceableAttributes.forEach(function (r) {
                        var attribute = attributes_1.find(function (a) { return a.name === r; });
                        if (attribute && !isDataValue(r, attribute.value)) {
                            attribute.value = "".concat(attribute.value, "__").concat(_this.hash);
                        }
                    });
                }
                if (d.children.length) {
                    return _this.updateSVGAttributes(d);
                }
                return d;
            });
            return node;
        }
    });
    Object.defineProperty(InlineSVG.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a = this.state, element = _a.element, status = _a.status;
            var _b = this.props, _c = _b.children, children = _c === void 0 ? null : _c, innerRef = _b.innerRef, _d = _b.loader, loader = _d === void 0 ? null : _d;
            var elementProps = omit(this.props, 'baseURL', 'cacheRequests', 'children', 'description', 'fetchOptions', 'innerRef', 'loader', 'onError', 'onLoad', 'preProcessor', 'src', 'title', 'uniqueHash', 'uniquifyIDs');
            if (!canUseDOM()) {
                return loader;
            }
            if (element) {
                return React.cloneElement(element, __assign({ ref: innerRef }, elementProps));
            }
            if ([STATUS.UNSUPPORTED, STATUS.FAILED].includes(status)) {
                return children;
            }
            return loader;
        }
    });
    Object.defineProperty(InlineSVG, "defaultProps", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            cacheRequests: true,
            uniquifyIDs: false,
        }
    });
    return InlineSVG;
}(React.PureComponent));
export default InlineSVG;
export * from './types';
//# sourceMappingURL=index.js.map